import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { OverhangCutType, OverhangSettings as OverhangSettingsData } from '@paragon/contract-library';
import { DistanceField } from '@paragon/material';

interface Props {
  readonly overhangSettings: OverhangSettingsData;
  readonly onChange: (overhangSettings: OverhangSettingsData) => void;
  readonly idPrefix?: string;
}

export function OverhangSettings({ overhangSettings, onChange, idPrefix }: Props) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', flex: 1, p: 1, justifyContent: 'space-evenly' }}>
      <FormControl variant="outlined" size="small" sx={{ m: 1, width: '45%' }}>
        <InputLabel htmlFor={`${idPrefix}overhang-label`}>Overhang Cut Type</InputLabel>
        <Select
          value={overhangSettings.overhangCutType}
          onChange={(event) => {
            onChange({ ...overhangSettings, overhangCutType: event.target.value as OverhangCutType });
          }}
          labelId={`${idPrefix}overhang-label`}
          id={`${idPrefix}overhang`}
          label="Overhang Cut Type"
        >
          <MenuItem value="Square">Square</MenuItem>
          <MenuItem value="Plumb">Plumb</MenuItem>
          <MenuItem value="Horizontal">Horizontal</MenuItem>
          <MenuItem value="Angle">Angle</MenuItem>
        </Select>
      </FormControl>
      <DistanceField
        label="Overhang Distance"
        value={overhangSettings.distance}
        onSubmit={(value) => {
          onChange({ ...overhangSettings, distance: value });
        }}
        sx={{ m: 1, width: '45%' }}
      />
    </Box>
  );
}
